import { render, staticRenderFns } from "./ScopeSelectorScopeGroup.vue?vue&type=template&id=ef5e5c98&scoped=true&"
import script from "./ScopeSelectorScopeGroup.vue?vue&type=script&lang=ts&"
export * from "./ScopeSelectorScopeGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5e5c98",
  null
  
)

export default component.exports